import Vue from 'vue'
import Router from 'vue-router'
import {routes} from './routes'
import store from '@/cache/store'
import services from '@/services/services'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return {
      x: 0,
      y: 0
    }
  }
})

function logged_in() {
  return new Promise((resolve, reject) => {
    let auth = store.getters.getAuth
    if (!auth.token && localStorage.hasOwnProperty('royal_experience_token'))
      auth.token = localStorage.royal_experience_token
  
    if (!auth.userId && localStorage.hasOwnProperty('royal_experience_userId'))
      auth.userId = localStorage.royal_experience_userId

    store.commit('authUser', auth)

    if (auth.token) {
      const response = services.checkToken()
      response
        .then((resp) => {
          resolve(auth)
        })
        .catch((resp)=> {
          console.log('rejected')
          reject('Invalid Token')
        })
    } else {
      reject('No User')
    }
  })
}

router.beforeEach((to, from, next) => {
  if (to.name === 'sign-out') {
    store.dispatch('unsetUser', {})
      .then(() => next({name: 'sign-in'}))
      .catch(error => console.log(error))
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    logged_in()
      .then(async (resp) => {
        if (!store.getters.isAdmin) {
          const response = await services.getUserInfo(resp.userId)
          store.dispatch('setUser', response.data)
            .then(() => {
              next()
            })
            .catch(error => {
              this.showError(error)
            })
        }
      })
      .catch((resp) => {
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
      })
  }

  next()
})

export default router